var map = {
	"./acomodar.png": 71247,
	"./autorelleno.png": 2569,
	"./buscarv.png": 80157,
	"./chatgpt.png": 7110,
	"./consecutivos.png": 23824,
	"./desplegables.png": 56076,
	"./engranes.png": 69216,
	"./filtros.png": 66178,
	"./formato.png": 93375,
	"./grabador.png": 52689,
	"./inmovilizar.png": 53849,
	"./menus.png": 41535,
	"./microsoft excel.png": 43126,
	"./pantalla.png": 74882,
	"./presentaciones.png": 83642,
	"./productividad.png": 7959,
	"./separar.png": 79699,
	"./tablas.png": 15912,
	"./whatsapp.png": 24761,
	"./zoom.png": 92002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39363;